import { render, staticRenderFns } from "./DashboardStaff.vue?vue&type=template&id=85390d16&scoped=true"
import script from "./DashboardStaff.vue?vue&type=script&lang=js"
export * from "./DashboardStaff.vue?vue&type=script&lang=js"
import style0 from "./DashboardStaff.vue?vue&type=style&index=0&id=85390d16&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85390d16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85390d16')) {
      api.createRecord('85390d16', component.options)
    } else {
      api.reload('85390d16', component.options)
    }
    module.hot.accept("./DashboardStaff.vue?vue&type=template&id=85390d16&scoped=true", function () {
      api.rerender('85390d16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/DashboardStaff.vue"
export default component.exports